import React from "react";
import DatePicker from "react-datepicker";
import Div from "./Div";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";
import { datePickerSetDate } from "../../../libraries/state_reducers/widget/DatePickerAlert";
import { removeModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../const/ModalKeys";

const DatePickerAlert = () => {
  const dispatch = useDispatch();

  const dateSelected: Date | null = useSelector(
    (state: RootState) => state.datePickerAlert.dateSelected
  );

  const onClickDate = (date: Date | null) => {
    dispatch(datePickerSetDate(date));
    dispatch(removeModal(ModalKeys.datepicker));
  };

  return (
    <Div className="pt-2 d-center">
      <DatePicker
        selected={dateSelected}
        onChange={(date: Date | null) => onClickDate(date)}
        dateFormat="dd/MM/yyyy"
        popperPlacement="bottom-start"
        minDate={new Date(Date.now())}
        inline
      />
    </Div>
  );
};

export default DatePickerAlert;
